export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Іздеу"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көрсетілетін бағандарды таңдау үшін басыңыз"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көрсетілетін бағандар"])}
}